import React, {useState} from 'react';
import ParametresGeneral from "./Parametres/ParametresGeneral";
import ParametresGestionEquipes from "./Parametres/ParametresGestionEquipes";
import {observer} from "mobx-react";
import {useStores} from "../../stores/Context";
import ParametresObjectifs from "./Parametres/ParametresObjectifs";
import ParametresHome from "./Parametres/ParametresHome";
import Sidebar from "../Siderbar";

const ParametragesSystemeHome = observer(() => {
    const {parametresStore} = useStores();

    return (
        <div style={{width: "100%"}}>
            <div className={"sidebarActive"}>
                {
                    parametresStore.viewGeneral ? (
                        <ParametresGeneral />
                    ) : parametresStore.viewEquipes ? (
                        <ParametresGestionEquipes  />
                    ) : parametresStore.viewObjectifs ? (
                        <ParametresObjectifs />
                    ) : parametresStore.viewHome ? (
                        <ParametresHome />
                    ) : null
                }
            </div>


        </div>

    );
});

export default ParametragesSystemeHome;